import React, { useState, useEffect } from 'react'
import { Link, useHistory } from 'react-router-dom'
import appRoutes from '../../routes/routeConfig'
import { Formik, Form } from 'formik'
import * as Yup from 'yup'
// import { forgotUserPassword } from '../../redux/api/userMgt'
import { useSnackbar } from 'notistack'
import { Button, CircularProgress } from '@mui/material'
import TextInput from '../../components/common/TextInput'

const ForgotPassword = () => {
    const { enqueueSnackbar } = useSnackbar();
    const [ error, setError ] = useState()
    const history = useHistory();

    const send = async (values, { setSubmitting, resetForm, setErrors }) => {
        setSubmitting(true)
        try {
            // await forgotUserPassword(values);
        }
        catch (err) {
            enqueueSnackbar(err?.message || 'An error occurred', { variant: 'error' })
            setError(err)
        }
        finally {
            setSubmitting(false)
        }
    } 

    return (
        <div className="account-body accountbg">
            <div className="container">
                <div className="row vh-100 d-flex justify-content-center">
                    <div className="col-12 align-self-center">
                        <div className="row">
                            <div className="col-lg-6 mx-auto">
                                <div className="card">
                                    <div className="card-body p-0 auth-header-box">
                                        <div className="text-center p-3">
                                            <Link to="/" className="logo logo-admin mt-05">
                                                <img src="assets/images/logo-sm.png" height="50" alt="CBN logo" className="auth-logo " />
                                            </Link>
                                            <h4 className="mt-1 mb-05 font-weight-semibold text-white font-18">Reset Password</h4>   

                                            <p className="text-white mb-0">Reset instructions will be sent to your email!</p>  
                                        </div>
                                    </div>
                                    <div className="card-body">
                                        <div className="tab-content">
                                            <div className="tab-pane active p-3 pt-1" id="LogIn_Tab" role="tabpanel">  
                                                <Formik
                                                    initialValues={{ username: '', password: '' }}
                                                    validationSchema={Yup.object().shape({
                                                        emailAddress: Yup.string().required('Email Address is required.')
                                                    })}
                                                    onSubmit={send}
                                                >
                                                    {({ isSubmitting }) => (
                                                        <Form className="form-horizontal auth-form">
                                                            <div className="form-group">                                                                                        
                                                                <TextInput label="Email Address" name="emailAddress" id="emailAddress" placeholder="Enter Email Address"  />                                 
                                                            </div>
                                                            <div className="form-group row mt-1">
                                                                <div className="col-sm-6">
                                                                </div>
                                                                <div className="col-sm-6 text-right">
                                                                    <p className="text-muted mb-0">Remember It ?  <Link to="/login" className="text-primary ml-0">Sign in here</Link></p>                                
                                                                </div>
                                                            </div>
                                                            { Boolean(error?.message) && <p className='error text-center'>{error?.message}</p> }
                                                            <div className="form-group mb-0 row">
                                                                <div className="col-12 mt-1">
                                                                    <button disabled={isSubmitting} className="btn btn-primary btn-block waves-effect waves-light" type="submit">
                                                                        {
                                                                            isSubmitting ? 
                                                                            <CircularProgress size={13} color='inherit' />
                                                                            :
                                                                            'Reset'
                                                                        }
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </Form>
                                                    )}
                                                </Formik>                                      
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card-body bg-light-alt text-center">
                                        <span className="text-muted d-none d-sm-inline-block">Central Bank of Nigeria &copy; { new Date().getFullYear()}</span>                                            
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ForgotPassword